const gutters = {};

export default gutters;
